import * as yup from 'yup';
import { isNotNil } from 'ramda';

const createPasswordValidator = ({
  minLength = 'Password must be at least 8 characters long',
  maxLength = 'Password cannot be more than 128 characters long',
  lowercase = 'Password must contain at least one lowercase letter',
  uppercase = 'Password must contain at least one uppercase letter',
  containNumber = 'Password must contain at least one number',
  specialCharacter = 'Password must contain at least one special character',
  required = 'Password is required',
} = {}) => {
  const owaspRules = [
    // require 8 characters at least
    (password) => {
      if (password.length < 8) {
        return minLength;
      }
      return null;
    },

    // require 128 characters max
    (password) => {
      if (password.length > 128) {
        return maxLength;
      }
      return null;
    },

    // require at least one lowercase letter
    (password) => {
      if (!/[a-z]/.test(password)) {
        return lowercase;
      }
      return null;
    },

    // require at least one uppercase letter
    (password) => {
      if (!/[A-Z]/.test(password)) {
        return uppercase;
      }
      return null;
    },

    // require at least one number
    (password) => {
      if (!/[0-9]/.test(password)) {
        return containNumber;
      }
      return null;
    },

    // require at least one special character
    (password) => {
      if (!/[^A-Za-z0-9]/.test(password)) {
        return specialCharacter;
      }
      return null;
    },
  ];

  return yup
    .string()
    .required(required)
    .test('validation-rules', function validateRules(value) {
      const errors = owaspRules.map((rule) => rule(value)).filter(isNotNil);
      if (errors.length) {
        return this.createError({
          message: errors.join('<br />'),
        });
      }
      return true;
    });
};

export default createPasswordValidator;
